<fgb-navigation-indicator></fgb-navigation-indicator>

<!-- <fgb-nav-bar *ifScreenSize="screenType.Desktop"></fgb-nav-bar> -->
<fgbcl-notification-toast></fgbcl-notification-toast>

<div id="main" role="main">
  <router-outlet></router-outlet>
</div>

<fgb-footer></fgb-footer>
